import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=f1c30416&scoped=true"
import script from "./DashboardView.ts?vue&type=script&lang=ts&external"
export * from "./DashboardView.ts?vue&type=script&lang=ts&external"
import style0 from "./DashboardView.scss?vue&type=style&index=0&id=f1c30416&prod&lang=scss&scoped=true&external"
import style1 from "./DashboardView.vue?vue&type=style&index=1&id=f1c30416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c30416",
  null
  
)

export default component.exports